import { render } from "./WhyUs.vue?vue&type=template&id=94559758&scoped=true"
import script from "./WhyUs.vue?vue&type=script&lang=js"
export * from "./WhyUs.vue?vue&type=script&lang=js"

import "./WhyUs.vue?vue&type=style&index=0&id=94559758&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94559758"]])

export default __exports__